/** 登入經理人帳號類型 */
export enum LoginManagerAccountType {
  /** 企業帳號 */
  CORPORATE_ACCOUNT = '1',
  /** 無限萬里遊帳號 */
  INFINITE_MILE_AGE_MEMBER_ACCOUNT = '2'
}
